import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/politique-de-confidentialite/PageClient.jsx");
